export const BUSINESS_PATH = "/apps/business";

export const BUSINESSES_LIST_PATH = `${BUSINESS_PATH}/businesses/list`;
export const getBusinessViewPath = (id: string | number) =>
  `${BUSINESS_PATH}/businesses/view/${id}`;

export const BUSINESS_POLICIES_LIST_PATH = `${BUSINESS_PATH}/policies/list`;
